import React from 'react';
// Components
import ScheduledStreamsTable from 'components/common/ScheduledStreamsTable';

const ManageOrganizationScheduledStreams: React.FC = () => {
  return <ScheduledStreamsTable />;
};

export default ManageOrganizationScheduledStreams;
